import React from 'react';
import Grid from "@material-ui/core/Grid";
import {Link} from "react-router-dom";

import footerBgShape from '../../images/footer-bg2.svg';
import logo from '../../images/Logo2.svg';

import './style.scss';


const Footer = () => {
    return(
        <Grid className="footerWrapper">
            <Grid container className="container" spacing={4}   justify="space-between">
                <Grid item xs={12} md={4}>
                    <Grid className="footerContact">
                        <Link to="/"><img src={logo} alt="logo"/></Link>
                        <ul>
                            <li>1 (800) 837-8793</li>
                            <li>info@onetwopay.ca </li>
                        </ul>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                    <Grid className="widget haslpadding">
                        <h4 className="widgetTitle">Quick Link</h4>
                        <ul className="quickLinks">
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/our-pay-stubs">Our Pay Stubs</Link></li>
                            <li><Link to="/contact-us">Contact</Link></li>
                            <li><Link to="/pricing">Pricing</Link></li>
                        </ul>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={4} sm={6}>
                    <h4 className="widgetTitle">Services</h4>
                    <ul className="quickLinks">
                        <li><Link to="/faq">Faq</Link></li>
                        <li><Link to="/terms-of-service">Terms of Service</Link></li>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                    </ul>
                </Grid>
            </Grid>
            <Grid className="container">
                <Grid className="footerBottom">
                    <Grid container spacing={4}>
                        <Grid item xs={12}>
                            <p>Copyrights 2020 OneTwoPay</p>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <img className="footerBgShape" src={footerBgShape} alt="footerBgShape"/>
        </Grid>
    )
};

export default Footer;